export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const FETCH_LOGIN = "FETCH_LOGIN";

export const doLogin = (name) => async (dispatch) => {};

export const doLogout = (name) => async (dispatch) => {};

